import { render, staticRenderFns } from "./updateOutsource.vue?vue&type=template&id=5952f9e4&"
import script from "./updateOutsource.vue?vue&type=script&lang=js&"
export * from "./updateOutsource.vue?vue&type=script&lang=js&"
import style0 from "./updateOutsource.vue?vue&type=style&index=0&id=5952f9e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports